module.exports = __webpack_public_path__ + "media/3x/J-b4e5903c.png";